// ... tus imports
import { useFormikContext } from 'formik';
import { MenuItem, Select, Box } from '@mui/material';
import InputField from '../../formFields/InputField';
import CheckboxField from '../../formFields/checkBoxField';
import { useSelector } from 'react-redux';
import AutocompleteField from '../../formFields/autocompleteField';
import AutocompleteMultiple from '../../formFields/AutocompleteMultiple';
import { useRef, useState } from 'react';

const fieldTypes = ["string", "number", "date", "boolean", "time", "select", "json"];
const operadores = ["+", "-", "*", "/"];

export const CrearCamposOrdenesServicios = (props: any) => {
  const { categoriaCotizacionesList }: any = useSelector((state: any) => state.categoriaCotizacion);
  const { fieldListSelect }: any = useSelector((state: any) => state.ordenesDeServicio);
  const { values, setFieldValue }: any = useFormikContext();

  const formulaRef = useRef<any>(null);

  const [dependenciasState, setDependenciasState] = useState<any[]>([]);
  const [operadorSeleccionado, setOperadorSeleccionado] = useState<string>("");

  const {
    formField: { name, etiqueta, tipoCampo, isRequired, opciones, categoria, dependencias, formula }
  } = props;

  // Inserta un campo en la fórmula con operador solo si hace falta
  const insertarCampoEnFormula = (campo: any, operador: string) => {
    if (!campo) return;

    let currentFormula = values[formula.name] || "";
    const cursorPos = formulaRef.current?.selectionStart || currentFormula.length;

    const antes = currentFormula.slice(0, cursorPos);
    const despues = currentFormula.slice(cursorPos);

    const regexOpFinal = /\s*([+\-*/])\s*$/;

    const nuevaFormula =
      regexOpFinal.test(antes) || !antes.trim()
        ? antes + campo.label + despues // ya hay operador o está vacío → solo campo
        : antes + ` ${operador} ` + campo.label + despues;

    setFieldValue(formula.name, nuevaFormula.trim());

    setTimeout(() => {
      if (formulaRef.current) {
        const newPos = antes.length + (regexOpFinal.test(antes) || !antes.trim() ? 0 : operador.length + 2) + campo.label.length;
        formulaRef.current.selectionStart = formulaRef.current.selectionEnd = newPos;
      }
    }, 0);
  };

  // Cuando cambia una dependencia
  const handleAddDependencia = (_event: any, newValue: any[]) => {
    const anterior = dependenciasState;
    setDependenciasState(newValue);

    if (newValue.length === 0) {
      setFieldValue(formula.name, "");
      setFieldValue(dependencias.name, []);
      return;
    }

    if (newValue.length < anterior.length) {
      const eliminados = anterior.filter(oldItem => !newValue.some(n => n.value === oldItem.value));

      if (eliminados.length > 0) {
        let formulaActual = values[formula.name] || "";
        eliminados.forEach(el => {
          const regex = new RegExp(`\\s*([+\\-*/])?\\s*${el.label}\\s*`, "g");
          formulaActual = formulaActual.replace(regex, "");
        });
        setFieldValue(formula.name, formulaActual.trim());
      }

      setFieldValue(dependencias.name, newValue);
      return;
    }

    const ultima = newValue[newValue.length - 1];
    if (ultima) {
      insertarCampoEnFormula(ultima, operadorSeleccionado || "+");
    }

    setFieldValue(dependencias.name, newValue);
  };

  // Maneja cambio de operador (solo reemplaza si ya hay algo)
  const handleOperadorChange = (op: string) => {
  setOperadorSeleccionado(op);

  const formulaActual = values[formula.name] || "";
  if (!formulaActual.trim() || !formulaRef.current) return;

  const cursorPos = formulaRef.current.selectionStart || 0;
  const antes = formulaActual.slice(0, cursorPos);
  const despues = formulaActual.slice(cursorPos);

  const regexOp = /([+\-*/])/;

  // 1️⃣ Si hay selección, reemplazar directamente lo seleccionado si es un operador
  if (formulaRef.current.selectionStart !== formulaRef.current.selectionEnd) {
    const seleccionado = formulaActual.slice(
      formulaRef.current.selectionStart,
      formulaRef.current.selectionEnd
    );
    if (regexOp.test(seleccionado)) {
      const nuevaFormula =
        formulaActual.slice(0, formulaRef.current.selectionStart) +
        ` ${op} ` +
        formulaActual.slice(formulaRef.current.selectionEnd);
      setFieldValue(formula.name, nuevaFormula.trim());
      return;
    }
  }

  // 2️⃣ Si no hay selección, buscar operador antes o después del cursor
  const regexOpFinal = /\s*([+\-*/])\s*$/; // antes
  const regexOpInicio = /^\s*([+\-*/])\s*/; // después

  if (regexOpFinal.test(antes)) {
    const nuevoAntes = antes.replace(regexOpFinal, ` ${op} `);
    setFieldValue(formula.name, (nuevoAntes + despues).trim());
  } else if (regexOpInicio.test(despues)) {
    const nuevoDespues = despues.replace(regexOpInicio, ` ${op} `);
    setFieldValue(formula.name, (antes + nuevoDespues).trim());
  }
};


  // Restringe input para que no escriba texto libre
  const handleFormulaKeyDown = (e: React.KeyboardEvent) => {
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
    const allowedOps = operadores;
    if (allowedKeys.includes(e.key) || allowedOps.includes(e.key)) return;
    e.preventDefault();
  };

  return (
    <>
      <InputField
        name={name.name}
        label={name.label}
        variant="outlined"
        autoComplete="off"
        fullWidth
      />

      <InputField
        name={etiqueta.name}
        label={etiqueta.label}
        variant="outlined"
        autoComplete="off"
        fullWidth
        margin="normal"
      />

      <InputField
        select
        label={tipoCampo.label}
        name={tipoCampo.name}
        fullWidth
        margin="normal"
      >
        {fieldTypes.map((type) => (
          <MenuItem key={type} value={type}>
            {type}
          </MenuItem>
        ))}
      </InputField>

      <AutocompleteField
        options={categoriaCotizacionesList}
        name={categoria.name}
        label={categoria.label}
        element={categoria.name}
        margin="normal"
      />

      {/* Campo fórmula con selector al lado */}
      <Box display="flex" alignItems="center" gap={1} marginY={2}>
        <InputField
          name={formula.name}
          label={formula.label}
          InputProps={{ readOnly: true }}
          variant="outlined"
          autoComplete="off"
          fullWidth
          inputRef={formulaRef}
          onKeyDown={handleFormulaKeyDown}
        />
        <Select
          value={operadorSeleccionado}
          onChange={(e) => handleOperadorChange(e.target.value)}
          displayEmpty
          sx={{ minWidth: 70 }}
        >
          <MenuItem value="">Op</MenuItem>
          {operadores.map((op) => (
            <MenuItem key={op} value={op}>
              {op}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <AutocompleteMultiple
        onChange={handleAddDependencia}
        options={fieldListSelect}
        name={dependencias.name}
        label={dependencias.label}
        element={dependencias.name}
        margin="normal"
        multiple
      />

      <CheckboxField name={isRequired.name} label={isRequired.label} />

      {values[tipoCampo.name] === 'select' && (
        <InputField
          name={opciones.name}
          label={opciones.label}
          fullWidth
          margin="normal"
        />
      )}
    </>
  );
};
